<template>
    <div class="modal fade" id="topFaqModal" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="modal-title">{{faqItem.title}}</div>
                    <div class="modal-text" >
                        <div class="item_answer" v-html="faqItem.content">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TopFaqPopup",
    props: {
        isShow: {
            type: Boolean
        },
        faqItem: {
            type: Object
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal-body {
    padding: 20px;
    margin-top: 20px;
}
.modal-dialog {
    top: 15%;
    
}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }
    .modal-title {
        font-size: 22px;
        color: #282b2c;
        font-weight: bold;
    }
    .modal-text {
        margin-top: 20px;
    }
    .item_answer {
        max-height: 450px;
        overflow: auto;
    }
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
